import { prefetchPathname } from "gatsby";

export const prefetch = (pathname: string) => {
    if (typeof window !== "undefined") {
        prefetchPathname(pathname);
    }
};